import { SavePlatformSettingsInput } from "../../../../types/gqlTypes/graphql"
import { SAVE_PLATFORM_SETTINGS } from "./platformSettingsMutations"

import { executeMutationSideload } from "../../../generic-services/helpers/studyPlan"

export async function savePlatformSettings(
  data: SavePlatformSettingsInput
): Promise<boolean> {
  const response = await executeMutationSideload(SAVE_PLATFORM_SETTINGS, {
    data
  })

  return response.platformSettings.savePlatformSettings
}
